import React, { useContext } from 'react';
import { Layout, Row, Col, Typography, Image as AntImage } from 'antd';
import { Context } from './store/Context';
import NavBar from './NavBar';
import AnimatedSection from './website_elements/AnimatedSection';
import MailingListSignup from './website_elements/MailingListSignup';
import CharacterProfile from './website_elements/CharacterProfile';
import NewsGallery from './website_elements/NewsGallery';
import ContactSection from './website_elements/ContactSection';
import { MailOutlined } from '@ant-design/icons';

// Helper component for section backgrounds (Same as Desktop)
const SectionWithBackground = ({ children, backgroundUrl, className = '', id = '' }) => (
    <section
        id={id}
        className={`section-with-bg ${className}`}
        style={{ backgroundImage: backgroundUrl ? `url(${backgroundUrl})` : 'none' }}
    >
        <div className="section-bg-overlay"></div> {/* Updated overlay */}
        <div className="section-content-wrapper container"> {/* Content wrapper */}
             {children}
        </div>
    </section>
);

function Mobile() {
    const { state } = useContext(Context);
    const {
        coverTitle, coverText1, coverText2, coverText3, coverImage, whiteSplash, // Ensure whiteSplash is here
        endorsementTitle, endorsementText,
        characters = [],
        appName
    } = state;

    const getBackground = (index) => characters[index % characters.length]?.background || null;

    // Prepare inline style for the splash background
    const splashStyle = whiteSplash ? { backgroundImage: `url(${whiteSplash})` } : {};

    return (
        <Layout>
             <NavBar /> {/* Ensure NavBar is included */}

            <Layout.Content>
                {/* Section 1: Hero */}
                <SectionWithBackground backgroundUrl={getBackground(0)} className="hero-section-bg" id="home-section">
                    <AnimatedSection className="hero-content-inner">
                        <div>
                            {/* Wrap rainbow text in span for clear styling */}
                            <h1 className="hero-main-title font-serif">
                                <span className="rainbow-text">{coverTitle}</span>
                            </h1>
                            <p>{coverText1}</p>
                            <p>{coverText2}</p>
                            <p>{coverText3}</p>
                        </div>
                         {/* Apply splash as background via inline style */}
                         <div className="hero-image-column" style={splashStyle}>
                            {/* REMOVED White Splash Image Element */}
                            {/* Main Hero Image (Front) */}
                            <AntImage src={coverImage} alt="Hero image" preview={false} className="hero-main-image"/>
                        </div>
                    </AnimatedSection>
                </SectionWithBackground>

                {/* Section 2: Mailing List */}
                <MailingListSignup
                    title={endorsementTitle}
                    text={endorsementText}
                    backgroundImage={getBackground(1)}
                    icon={<MailOutlined />}
                 />

                {/* Section 3: Character Profiles */}
                {/* Mobile doesn't typically use the 'reverse' prop, all stacked */}
                 <div id="team-section"> {/* Simple ID wrapper */}
                    {characters.map((character, index) => (
                        <SectionWithBackground
                            key={character.id}
                            backgroundUrl={character.background}
                            className="character-profile-bg-section"
                         >
                            {/* Conditionally render "Meet the Team" title in the first section */}
                            {index === 0 && (
                                <h2 className="team-section-title font-serif">
                                    Meet the Team
                                </h2>
                            )}
                            {/* CharacterProfile content (no reverse needed) */}
                            <CharacterProfile character={character} />
                        </SectionWithBackground>
                    ))}
                </div>

                {/* Section 4: News Gallery */}
                <NewsGallery backgroundUrl={getBackground(characters.length)} />

                {/* Section 5: Contact */}
                <ContactSection backgroundUrl={getBackground(characters.length + 1)} />


                {/* Footer */}
                 <Row
                    justify="center"
                    align='middle'
                    className="footer-blur-effect"
                    style={{ padding: '20px 0 40px 0' }}
                >
                    <Col>
                        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                            {appName} © {new Date().getFullYear()}
                        </Typography.Text>
                    </Col>
                </Row>

            </Layout.Content>
        </Layout>
    );
}

export default Mobile;